import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import React from 'react';

import { PageHeaderMeta } from '@/components/PageHeaderMeta/PageHeaderMeta';
import useAddNotificationCountToTitle from '@/hooks/useAddNotificationCountToTitle';

type Props = {
    baseUrl: string;
};

const ReviewPageHeaderMeta = ({ baseUrl }: Props) => {
    const { formatMessage } = useIntl();

    const description = formatMessage({ id: 'get_in_on_the_auction' });
    const title = useAddNotificationCountToTitle(formatMessage({ id: 'review_page.review_your_auction' }));
    const canonical = `${baseUrl}/review`;

    return (
        <PageHeaderMeta
            canonical={canonical}
            description={description}
            title={title}
        />
    );
};

export default React.memo<Props>(ReviewPageHeaderMeta);
